// Status da configuração: chip suave com dot E texto — a cor nunca fala sozinha.
import { useTranslation } from "react-i18next"

import { cn } from "@/lib/utils"

import { STATUS_CHIP_CLASSES } from "../constants"

const prefix = "pages.paymentConfigurations"

interface PaymentConfigurationStatusChipProps {
  active: boolean
  className?: string
}

export const PaymentConfigurationStatusChip = ({
  active,
  className,
}: PaymentConfigurationStatusChipProps) => {
  const { t } = useTranslation()
  const classes = active
    ? STATUS_CHIP_CLASSES.active
    : STATUS_CHIP_CLASSES.inactive

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        classes.chip,
        className
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          "h-1.5 w-1.5 rounded-full",
          classes.dot
        )}
      />
      {active
        ? t(`${prefix}.status.active`)
        : t(`${prefix}.status.inactive`)}
    </span>
  )
}
